import ANGOnboardingModal from './ANGOnboardingModal.container';

export default ANGOnboardingModal;
